import { useCallback, useEffect, useRef, useState } from 'react';

export const ADDED_CONFIRM_MS = 1400;

/**
 * "Added ✓" confirm state for an add-to-bag button (like the app): `confirm()`
 * turns it on, it reverts on its own after `ms`. Calling again restarts the
 * timer. The state is information, not decoration, so it also shows with
 * reduced motion (only the check's entrance animation is dropped).
 */
const useAddedConfirm = (ms = ADDED_CONFIRM_MS) => {
  const [added, setAdded] = useState(false);
  const timer = useRef(null);

  const confirm = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    setAdded(true);
    timer.current = setTimeout(() => {
      timer.current = null;
      setAdded(false);
    }, ms);
  }, [ms]);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  return [added, confirm];
};

export default useAddedConfirm;
